var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgSidebarNav6(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 36,
    viewBox: "0 0 40 36",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Nav-tabs"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Frame"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M20 25.4999V13.8333",
    stroke: "black",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M23.3334 17.9999L25 19.6666L28.3334 16.3333",
    stroke: "black",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_3",
    d: "M28.3333 13V11.3333C28.3333 11.1123 28.2455 10.9004 28.0892 10.7441C27.9329 10.5878 27.721 10.5 27.5 10.5H23.3333C22.4492 10.5 21.6014 10.8512 20.9763 11.4763C20.3511 12.1014 20 12.9493 20 13.8333C20 12.9493 19.6488 12.1014 19.0236 11.4763C18.3985 10.8512 17.5507 10.5 16.6666 10.5H12.5C12.2789 10.5 12.067 10.5878 11.9107 10.7441C11.7544 10.9004 11.6666 11.1123 11.6666 11.3333V22.1667C11.6666 22.3877 11.7544 22.5996 11.9107 22.7559C12.067 22.9122 12.2789 23 12.5 23H17.5C18.163 23 18.7989 23.2634 19.2677 23.7322C19.7366 24.2011 20 24.837 20 25.5C20 24.837 20.2634 24.2011 20.7322 23.7322C21.201 23.2634 21.8369 23 22.5 23H27.5C27.721 23 27.9329 22.9122 28.0892 22.7559C28.2455 22.5996 28.3333 22.3877 28.3333 22.1667V21.0833",
    stroke: "black",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSidebarNav6);
export default __webpack_public_path__ + "static/media/sidebar-nav-6.c91bbc06ad7fbdd33a30e0d82d0d2966.svg";
export { ForwardRef as ReactComponent };